import { useCallback, useMemo, useState } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import { withPatternFill } from "../../lib/charts/chartPatternFill";

// Manages the pattern fill toggle of a chart, returning the chart options to display and
// whether the pattern fill is currently enabled.
export const usePatternFill = (chartOptions, allowDisplayingPatternFill) => {
  const [enabled, setEnabled] = useState(false);
  const t = useFormatMessage();

  const handleToggled = useCallback(() => {
    setEnabled(currentlyEnabled => !currentlyEnabled);
  }, []);

  const displayedChartOptions = useMemo(() => {
    if (!allowDisplayingPatternFill) return chartOptions;

    const labels = {
      enable: t(intlMessages.enable),
      disable: t(intlMessages.disable)
    };

    return withPatternFill(chartOptions, { enabled, labels, onToggle: handleToggled });
  }, [allowDisplayingPatternFill, chartOptions, enabled, handleToggled, t]);

  return { chartOptions: displayedChartOptions, patternFillEnabled: enabled };
};

const intlMessages = defineMessages({
  enable: {
    id: "participativeModuleResults.formField.enablePatternFill",
    defaultMessage: "Activer les motifs accessibles"
  },
  disable: {
    id: "participativeModuleResults.formField.disablePatternFill",
    defaultMessage: "Désactiver les motifs accessibles"
  }
});
